<template>
    <div class="main-box">
        <div class="box-header">
            <i class="el-icon-close" @click="$emit('componentIndex',1)"></i>
            <span>Add New Address</span>
        </div>
        <div class="box-content">
            <scroll-wrap>
                <div class="box-content-wrap">
                    <el-form ref="addressForm" :model="address" :rules="addressRules" :label-position="'top'"
                             :inline="true" class="custom-el-form"
                             size="small">
                        <el-form-item prop="firstname"  label="First Name" style="width: calc(50% - 5px)">
                            <el-input autocomplete="new-aaa" v-model="address.firstname"></el-input>
                        </el-form-item>
                        <el-form-item prop="lastname"  label="Last Name" class="mr0" style="width: calc(50% - 5px)">
                            <el-input autocomplete="new-aaa" v-model="address.lastname"></el-input>
                        </el-form-item>
                        <el-form-item prop="addressline1"  label="Address Line 1" class="mr0" style="width: 100%">
                            <el-input autocomplete="new-aaa" v-model="address.addressline1"></el-input>
                        </el-form-item>
                        <el-form-item prop="addressline2"  label="Address Line 2" class="mr0" style="width: 100%">
                            <el-input autocomplete="new-aaa" v-model="address.addressline2"></el-input>
                        </el-form-item>
                        <el-form-item prop="country"  label="Country" style="width: calc(50% - 5px)">
                            <el-select v-model="address.country" placeholder="请选择">
                                <el-option
                                        v-for="item in countrylist"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="state"  label="State/Province" class="mr0" style="width: calc(50% - 5px)">
                            <el-input autocomplete="new-aaa" v-model="address.state"></el-input>
                        </el-form-item>
                        <el-form-item prop="city"  label="City" style="width: calc(50% - 5px)">
                            <el-input autocomplete="new-aaa" v-model="address.city"></el-input>
                        </el-form-item>
                        <el-form-item prop="receiptCode"  label="Zip/Postal Code" class="mr0" style="width: calc(50% - 5px)">
                            <el-input autocomplete="new-aaa" type="number" v-model="address.receiptCode"></el-input>
                        </el-form-item>
                        <el-form-item prop="receiptPhone"  label="Phone" class="mr0" style="width: 100%">
                            <el-input autocomplete="new-aaa" v-model="address.receiptPhone"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </scroll-wrap>
            <div class="message-alert">

            </div>
        </div>
        <div class="box-footer">
            <span class="addNewAddress" @click="addNewAddress">
                Save
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Shipping-Address",
        data() {
            return {
                address: {
                    receiptName: '',
                    firstname: '',
                    lastname: '',
                    receipt: '',
                    receiptPhone: '',
                    receiptCode: '',
                    label: '',
                    country: '',
                    state: '',
                    city: '',
                    addressline1: '',
                    addressline2: '',
                },
                addressRules: {
                    receiptName: [
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    firstname: [{required: true, message: '必填项', trigger: 'blur'}],
                    lastname: [{required: true, message: '必填项', trigger: 'blur'}],
                    receipt: [{required: true, message: '必填项', trigger: 'blur'}],
                    receiptPhone: [{required: true, message: '必填项', trigger: 'blur'}],
                    receiptCode: [{required: true, message: '必填项', trigger: 'blur'}],
                    label: [{required: true, message: '必填项', trigger: 'blur'}],
                    country: [{required: true, message: '必填项', trigger: 'blur'}],
                    state: [{required: true, message: '必填项', trigger: 'blur'}],
                    city: [{required: true, message: '必填项', trigger: 'blur'}],
                    addressline1: [{required: true, message: '必填项', trigger: 'blur'}],
                    addressline2: [{required: true, message: '必填项', trigger: 'blur'}],
                },
                countrylist: [],
                newAddress: {}
            }
        },
        created() {
            this.axios.get('/data/enCountry.json').then(res => {
                this.countrylist = res.items
            })
        },
        methods: {
            addNewAddress() {
                this.$refs['addressForm'].validate((valid) => {
                    if (valid) {
                        this.address.receiptName = this.address.firstname + this.address.lastname;
                        let $receipt = {
                            country: this.address.country,
                            state: this.address.state,
                            city: this.address.city,
                            addressline1: this.address.addressline1,
                            addressline2: this.address.addressline2,
                        }
                        this.address.receipt = JSON.stringify($receipt)
                        this.axios.post('/student/user/buyer/address/create', this.address).then(res => {
                            if (res.succeed) {
                                this.newAddress = res.address;
                                this.$emit('componentIndex', 1)
                            }
                        })
                    } else {
                        return false;
                    }
                });


            }
        }
    }
</script>

<style scoped lang="scss">
    div.main-box {
        position: relative;
        overflow: hidden;
        border-radius: 0 0 20px 20px;

        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            opacity: 0;
            background: rgba(0, 0, 0, 0.5);
            z-index: -1;
            border-radius: 0 0 20px 20px;
            transition: z-index 0s linear 0.3s, opacity 0.3s linear;
        }

        &.mask-layer:before {
            transition: z-index 0s linear 0s;
            opacity: 1;
            z-index: 9998;
        }

        div.box-header {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 52px;
            line-height: 52px;
            border-bottom: 1px solid #ededed;
            box-sizing: border-box;

            > i {
                position: absolute;
                top: 50%;
                left: 0;
                font-weight: bolder;
                transform: translateY(-50%);
                font-size: 18px;
                padding: 10px;
                cursor: pointer;

                &:hover {
                    opacity: 0.8;
                }
            }

            > span {
                font-size: 18px;
                color: #000000;
                font-weight: bolder;
            }
        }

        div.box-content {
            position: relative;
            height: calc(100% - 104px);
            background: #FFFFFF;

            div.box-content-wrap {
                .custom-el-form {
                    display: flex;
                    flex-wrap: wrap;
                    padding: 10px;
                    box-sizing: border-box;
                    justify-content: center;

                    > .el-form-item {
                        margin-bottom: 18px;

                        &.mr0 {
                            margin-right: 0;
                        }

                        ::v-deep .el-form-item__label {
                            padding: 0;
                            line-height: 26px;
                        }

                        ::v-deep input {
                            border-color: #A7DFE5;
                            background: #E6F5F6;
                        }
                    }
                }
            }

            div.message-alert {
                width: 100%;
                padding: 20px 0;
                background: #FFFFFF;
                position: absolute;
                bottom: -300px;
                left: 0;
                z-index: 9999;
                transition: bottom 0.3s linear;
                border-radius: 0 0 22px 22px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                &.active {
                    bottom: -52px;
                    transition: bottom 0.3s linear;
                }

                > .img {
                    width: 80px;
                    height: 80px;
                    margin-bottom: 20px;

                    > img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                > .txt {
                    font-weight: bolder;
                    margin-bottom: 10px;
                }

                > .price {
                    font-weight: lighter;
                    font-size: 12px;
                }
            }
        }

        div.box-footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 12px;
            box-sizing: border-box;
            height: 52px;
            box-shadow: 0 0 1px #373737;

            span.addNewAddress {
                width: 100%;
                height: 30px;
                background: #089BAB;
                color: #FFFFFF;
                font-size: 14px;
                font-weight: bolder;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 3px;
                cursor: pointer;
                transition: opacity 0.3s linear;

                &:hover {
                    opacity: 0.8;
                    transition: opacity 0.3s linear;
                }
            }
        }
    }
</style>
